import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p", "br", "div", "span", "strong", "b", "em", "i", "u", "s", "strike",
  "h2", "h3", "h4", "ul", "ol", "li", "blockquote", "a", "hr",
];
const ALLOWED_ATTR = ["href", "target", "rel", "style"];

let hooksAdded = false;
const addHooks = () => {
  if (hooksAdded) return;
  hooksAdded = true;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      const href = node.getAttribute("href") || "";
      if (!/^(https?:|mailto:)/i.test(href)) node.removeAttribute("href");
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
    // Only keep text alignment from inline styles
    if (node.hasAttribute?.("style")) {
      const match = /text-align:\s*(left|right|center|justify)/i.exec(node.getAttribute("style") || "");
      if (match) node.setAttribute("style", `text-align: ${match[1].toLowerCase()}`);
      else node.removeAttribute("style");
    }
  });
};

export const isHtml = (text?: string | null) => !!text && /<\/?[a-z][\s\S]*>/i.test(text);

export const sanitizeHtml = (html: string): string => {
  addHooks();
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
};

// Plain text for previews, search and meta descriptions
export const htmlToText = (text?: string | null): string => {
  if (!text) return "";
  if (!isHtml(text)) return text;
  const doc = new DOMParser().parseFromString(sanitizeHtml(text), "text/html");
  doc.querySelectorAll("p, div, li, h2, h3, h4, br, blockquote").forEach((el) => el.append(" "));
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
};

export const isRichTextEmpty = (html?: string | null) => htmlToText(html).length === 0;
